<template>
  <AppSection id="timesheet-details" type="page" :title="$t($getConst.menu.timesheets.name)"
              :button="true"
              :button-disabled="timesheetIds.indexOf(timesheet_id) === timesheetIds.length-1"
              :button-icon="$getConst.icons.next"
              button-variant="primary"
              @onClick="goToNextTimesheet"
              :second-button="true"
              :second-button-disabled="timesheetIds.indexOf(timesheet_id) === 0"
              :second-button-icon="$getConst.icons.previous"
              second-button-variant="primary"
              @onClickSecondButton="goToPreviousTimesheet"
              :first-button-tooltip="$t($getConst.pages.timesheet.forward)"
              :second-button-tooltip="$t($getConst.pages.timesheet.backward)"
  >

    <AppSpinner
      v-if="isLoading || isError"
      class="text-secondary mx-auto mt-5"
      size="5"
    />
    <template v-else>


      <TimesheetDetailsHeader
        :status="timesheet.Status || ''"
        :job-title="timesheet.JobTitle || ''"
        :company-name="timesheet.CompanyName || ''"
        :contract-id="timesheet.ContractID || ''"
        :timesheet-id="timesheet.ID || ''"
        :start-date="timesheet.TimesheetStartDate || ''"
        :approvers-names="approversNames || ''"
        :timesheet="timesheet"
      />

      <template v-if="timesheet.Frequency.toLowerCase() === 'monthly'">
        <WeeklyTimesheet
          v-if="isMobileView"
          :timesheet="timesheet"
          :is-mobile-view="isMobileView"
          :timesheetStd="timesheetStd"
        />
        <MonthlyTimesheet
          v-else
          :timesheet="timesheet"
          :is-mobile-view="isMobileView"
          :timesheetStd="timesheetStd"
        />
      </template>

      <WeeklyTimesheet
        v-else-if="timesheet.Frequency.toLowerCase() === 'weekly'.toLowerCase()"
        :timesheet="timesheet"
        :is-mobile-view="isMobileView"
        :timesheetStd="timesheetStd"
      />

    </template>
  </AppSection>
</template>

<script>
  import AppSection from "../../../components/common/sections/AppSection";
  import TimesheetDetailsHeader from "./TimesheetDetailsHeader";
  import {getTimesheet} from "../../../api/timesheet.api";
  import AppSpinner from "../../../components/common/utils/AppSpinner";
  import MonthlyTimesheet from "./MonthlyTimesheet";
  import WeeklyTimesheet from "./WeeklyTimesheet";
  import {getSmartWorking} from "../../../shared/services/timesheets";

  export default {
    name: "index",
    components: {WeeklyTimesheet, MonthlyTimesheet, AppSpinner, TimesheetDetailsHeader, AppSection},
    props: {
      timesheet_id: null,
      nav_scope_id: null,
      timesheet_status: null
    },
    data() {
      return {
        timesheet: null,
        approversNames: [],
        screenWidth: 0,
        isLoading: false,
        isError: false,
        timesheetIds: [],
        timesheetStd: null,
      }
    },
    computed: {
      isMobileView() {
        return this.screenWidth < this.$getConst.breakpoints.md;
      },
      indexOfCurrentTimesheetId() {
        return this.timesheetIds.indexOf(this.timesheet_id);
      },
    },
    methods: {
      formatFileName(name) {
        const indexStartName = name.split("_", 2).join("_").length + 1;
        if (indexStartName > name.length) {
          return name;
        }
        return name.substr(indexStartName);
      },
      getTimesheet() {
        this.isLoading = true;
        this.isError = false;
        getTimesheet(this.timesheet_id, this.nav_scope_id).then(
          (response) => {
            this.timesheet = response.data.Timesheet;
            this.timesheet.Approvers.forEach(approver => {
              if (approver.id > 0) {
                this.approversNames.push(approver.name);
              }
            });
            this.timesheet.Attachments.forEach(attachment => {
              attachment.FileName = this.formatFileName(attachment.FileName);
            });
            this.isLoading = false;
            this.getTimesheetStandardHours(this.timesheet.Unit);
          },
          (error) => {
            this.isError = true;
            this.handleApiError(error);
            this.$router.push({name: this.$getConst.routesNames.timesheets});
            this.isLoading =false;
          }
        )
      },
      goToPreviousTimesheet() {
        this.$router.push(
          {
            name: this.$getConst.routesNames.timesheetDetails,
            params: {
              timesheet_id: this.timesheetIds[this.indexOfCurrentTimesheetId-1],
              nav_scope_id: this.nav_scope_id,
              timesheet_status: this.timesheet_status
            }
          }
        );
      },
      goToNextTimesheet() {
        this.$router.push(
          {
            name: this.$getConst.routesNames.timesheetDetails,
            params: {
              timesheet_id: this.timesheetIds[this.indexOfCurrentTimesheetId+1],
              nav_scope_id: this.nav_scope_id,
              timesheet_status: this.timesheet_status
            }
          }
        );
      },
      getTimesheetStandardHours(unit) {
        let max = 1;
        for(let day of this.timesheet.Days.Days) {
          max = Math.max(max,parseFloat(day.std))
        }
        // temporary for italian scope
        if (this.$store.getters['auth/allScopes'][0].id===12) {
          if (unit==="Hour"){
            this.timesheetStd = 8
          }else {
            this.timesheetStd = 1
          }
        }else{
          this.timesheetStd = max
        }
        console.log(this.$store.getters['auth/allScopes'][0].id)
        console.log(this.timesheetStd)
        console.log(unit)
      }
    },
    mounted() {
      switch (this.timesheet_status) {
        case "awaiting_submission":
          this.timesheetIds = this.$store.getters['timesheets/getAwaitingSubmissionTimesheet'];
          break;
        case "submitted":
          this.timesheetIds = this.$store.getters['timesheets/getSubmittedTimesheets'];
          break;
        case "awaiting_approval":
          this.timesheetIds = this.$store.getters['timesheets/getAwaitingApprovalTimesheets'];
          break;
        case "approved":
          this.timesheetIds = this.$store.getters['timesheets/getApprovedTimesheets'];
          break;
      }
    },
    created() {
      this.getTimesheet();
      window.addEventListener('resize', () => {this.screenWidth = window.innerWidth});
      this.screenWidth = window.innerWidth;
    },
    destroyed() {
      window.removeEventListener('resize', () => {this.screenWidth = window.innerWidth});
    },
  }
</script>

<style scoped>
  .calendar a:hover {
    text-decoration: none;
  }
</style>
